export class OrderDocument {
    id: number;
    order_id: number;
    type: string;
    version: number;
    filename: string;
    created_at: string;
    updated_at: string;
}


// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/order_document.ts